// ─── English locale ───────────────────────────────────────────────────────────
const en = {
  // ── Navbar ──────────────────────────────────────────────────────────────────
  nav: {
    items: ["about", "experience", "projects", "skills", "contact"],
    labels: {
      about: "About",
      experience: "Experience",
      projects: "Projects",
      skills: "Skills",
      contact: "Contact",
    },
    logoAriaLabel: "Go to top",
    hamburgerAriaLabel: "Toggle menu",
    themeToggleDark: "Switch to Day mode",
    themeToggleLight: "Switch to Night mode",
    langToggleAriaLabel: "Switch language",
  },

  // ── HeroSection ─────────────────────────────────────────────────────────────
  hero: {
    role: "Data Scientist · AI Engineer · Product Manager",
    headline1: "Adil",
    headline2: "Ibraheem Koyava",
    subtitle:
      "M.Sc. Business Intelligence & Data Analytics at Emden/Leer University of Applied Sciences. 4+ years as Associate Product Manager in EdTech and Media, now building Agentic RAG pipelines and full-stack AI applications.",
    cta: "Get in Touch",
    stats: [
      { label: "Years Exp.", value: "4+" },
      { label: "Companies", value: "3" },
      { label: "Languages", value: "4" },
    ],
    location: "Hamburg, Germany",
    scrollLabel: "SCROLL",
  },

  // ── AboutSection ────────────────────────────────────────────────────────────
  about: {
    tag: "// about me",
    titleLine1: "The Person",
    titleLine2: "Behind the Code",
    bio1: "M.Sc. student in Business Intelligence & Data Analytics at Emden/Leer University of Applied Sciences, Germany. 3+ years as Associate Product Manager across EdTech and Media — launching features, running A/B tests, and owning roadmaps.",
    bio2: "I combine that product instinct with hands-on AI engineering: building Agentic RAG pipelines, fine-tuning LLMs, and shipping full-stack AI applications that solve real problems. Core stack: Python, FastAPI, LangChain, Pinecone, React.",
    highlightLabel: "Core skills",
    cards: [
      {
        title: "Education",
        desc: "M.Sc. Business Intelligence & Data Analytics — Emden/Leer University of Applied Sciences, Germany",
      },
      {
        title: "Location",
        desc: "Hamburg, Germany",
      },
      {
        title: "Languages",
        desc: "English · German · Malayalam · Tamil",
      },
      {
        title: "Focus Areas",
        desc: "Agentic RAG · LLM Engineering · Product Management · AI Applications",
      },
    ],
  },

  // ── ExperienceSection ───────────────────────────────────────────────────────
  experience: {
    tag: "// work history",
    titleLine1: "Professional",
    titleLine2: "Experience",
  },

  // ── ProjectsSection ─────────────────────────────────────────────────────────
  projects: {
    tag: "// portfolio",
    titleLine1: "Featured",
    titleLine2: "Projects",
    viewOnGitHub: "View on GitHub",
  },

  // ── SkillsSection ───────────────────────────────────────────────────────────
  skills: {
    tag: "// technical skills",
    title: "My Toolkit",
    certificationsLabel: "Certifications & Achievements",
    certsSubLabel: "Certifications",
    achievementsSubLabel: "Achievements",
  },

  // ── ContactSection ──────────────────────────────────────────────────────────
  contact: {
    tag: "// contact",
    titleLine1: "Let's Work",
    titleLine2: "Together",
    description:
      "Open to collaborations, research opportunities, and interesting problems in AI engineering and product. Based in Hamburg, Germany — open to remote and on-site roles.",
    labels: {
      email: "Email",
      phone: "Phone",
      github: "GitHub",
      linkedin: "LinkedIn",
      location: "Location",
    },
  },

  // ── Footer ──────────────────────────────────────────────────────────────────
  footer: {
    builtWith: "Built with",
    by: "by Adil Ibraheem Koyava",
    copyright: "© 2026 · Hamburg, Germany",
  },

  // ── ChatWidget ──────────────────────────────────────────────────────────────
  chat: {
    headerTitle: "Ask about Adil",
    headerSub: "RAG AI assistant · usually instant",
    welcomeText:
      "Hi! I'm Adil's AI assistant. Ask me about his experience, projects, or skills.",
    placeholder: "Ask anything about Adil...",
    faqLabel: "Frequently asked",
    faqChips: [
      "What's your work experience?",
      "Tell me about your projects",
      "What skills do you have?",
    ],
    errorFallback: "Something went wrong. Please try again.",
    connectionError: "Connection error. Please try again.",
    retryBtn: "Try again",
    typingAriaLabel: "AI is typing",
    messagesAriaLabel: "Chat messages",
    dialogAriaLabel: "Chat with Adil's AI assistant",
    closeBtnAriaLabel: "Close chat",
    inputAriaLabel: "Type your message",
    sendAriaLabel: "Send message",
    toggleOpenAriaLabel: "Open AI chat about Adil",
    toggleCloseAriaLabel: "Close chat",
    tooltip:
      "RAG-powered AI assistant trained on Adil's resume, projects and skills",
  },
};

export default en;
